import React from 'react'

import { Skeleton } from 'antd'

import { getForSave } from 'core/application/account/nonEligibleEmployeeSignup'
import signupController from 'core/application/account/nonEligibleEmployeeSignup'
import perksCreateNonEEAccount from 'core/application/account/perksCreateNonEEAccount'
import { ProductIds } from 'core/application/commons/config'

import useQueryRequest from 'common/hooks/useQueryRequest'
import useUrlQueryParam from 'common/hooks/useUrlQueryParam'

import { ROUTE_PATHS } from 'common/routePaths'

import EmployeeSignup from '../EmployeeSignup'

export const NON_ELIGIBLE_EMPLOYEE_SIGNUP = '/non-ee-signup'

const NonEligibleEmployeeSignup = () => {
  const code = useUrlQueryParam('code')
  const [user] = useQueryRequest(null, () => getForSave(code))

  const headerTitle =
    user?.productId === ProductIds.Perks
      ? 'PeopleKeep WorkPerks Management'
      : user?.productId === ProductIds.QsehraId
      ? 'PeopleKeep QSEHRA Customer value'
      : 'PeopleKeep Group Coverage HRA Management'

  const signupHandler = user
    ? user.productId === ProductIds.Perks
      ? perksCreateNonEEAccount
      : signupController
    : () => Promise.resolve()
  return (
    <Skeleton active={true} loading={!user}>
      {user && (
        <EmployeeSignup
          initialValues={{
            ...user,
          }}
          headerTitle={headerTitle}
          signupFlowPath={ROUTE_PATHS.NON_ELIGIBLE_EMPLOYEE_SIGNUP_FLOW}
          signupController={signupHandler}
        />
      )}
    </Skeleton>
  )
}

export default NonEligibleEmployeeSignup
